@if (vm$ | async; as model) {
    <span class="quick-bet-counter">{{ model.pickCount }}</span>
    <div>
        @if (isUserBalanceEnabled && (isAuthenticated$ | async)) {
            <span class="quick-bet-header-title">{{ sitecore.quickBetMessages.Balance }}: {{ accountBalance() | msCurrency: true }}</span>
        } @else {
            <span class="quick-bet-header-title">{{ sitecore.quickBetHelp.Title }}</span>
        }
        @if (model.returnsMessage) {
            <div class="return-message" [innerHTML]="model.returnsMessage | msTrust: 'html'"></div>
        }
    </div>

    @if (isClearCtaTextEnabled) {
        <button
            class="close-button-epcot"
            ds-button
            msThemedButton
            size="medium"
            variant="outline"
            kind="secondary"
            [themeInverse]="buttonThemeInverse"
            (click)="closeQuickBet($event)">
            {{ sitecore.quickBetMessages.CloseButton }}
        </button>
    } @else {
        <button
            msThemedIconButton
            ds-button-icon
            size="small"
            variant="flat"
            kind="tertiary"
            [themeInverse]="chevronThemeInverse"
            (click)="closeQuickBet($event)">
            <vn-icon class="quick-bet-down-icon" name="theme-down" size="17"></vn-icon>
        </button>
    }
}
